export const sidebar = function(){
    arrowDown();
}

function arrowDown(){
    let menu = document.querySelector('.sidebar-menu');
    if (!menu) {
        return false;
    }

    let items = menu.querySelectorAll('ul>li>a');
    items.forEach(function(item:HTMLElement){
        item.onclick = function(el){
            // el.preventDefault();
            
            let parents = item.parentElement.parentElement;

            if (!parents){
                return false;
            }
            let children = parents.children;
            let countChild = children.length;

            for(let i = 0; i < countChild; ++i){
                children[i].children[0].classList.remove('active');

                let ulChild = children[i].querySelectorAll('ul>li>a');
                ulChild.forEach(function(itemUlChild){
                    itemUlChild.classList.remove('active');
                })
            }

            item.classList.add('active');
            // let ulItem = item.parentElement.querySelectorAll('ul>li');
            // if (ulItem.length > 0){
            //     ulItem[0].children[0].classList.add('active');
            // }
        }
    })
}